import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './LoadMoreButton.scss';

export default function LoadMoreButton({ children, disabled, ...rest }) {
    const { t } = useTranslation('cards');

    return (
        <div className={styles.root}>
            <span className={cn({ [styles.button]: true, [styles.disabled]: disabled })} {...rest}>
                {children ? children : t('PageProductsMain.loadMore')}
            </span>
        </div>
    );
}

LoadMoreButton.propTypes = {
    children: PropTypes.node,
    disabled: PropTypes.bool,
};

LoadMoreButton.defaultProps = {
    disabled: false,
};
